import { render, staticRenderFns } from "./SassFeature.vue?vue&type=template&id=76fdca0c&"
import script from "./SassFeature.vue?vue&type=script&lang=js&"
export * from "./SassFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports